import { useDispatch } from 'react-redux';
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import { closeDialog, openDialog } from 'app/store/fuse/dialogSlice';
import { EditorHtmlField, useModel, useSettings, Utils } from 'app/main/components';

interface InvoicesDeadlinesEditNotesDialogProps {
	model: any;
	updateRefresh?: VoidFunction;
}

export const showInvoicesDeadlinesEditNotesDialog = (props: InvoicesDeadlinesEditNotesDialogProps) =>
	openDialog({
		children: <InvoicesDeadlinesEditNotesDialog {...props} />,
		maxWidth: 'sm',
		fullWidth: true,
		onClose: () => {}
	});

export default function InvoicesDeadlinesEditNotesDialog(props: InvoicesDeadlinesEditNotesDialogProps) {
	const dispatch = useDispatch();
	const { settings, t } = useSettings('invoices_deadlines');

	const { model, sendChange, save } = useModel({ baseModel: props.model, settings, isEdit: true });

	const updateNotes = () => {
		save({
			storedName: 'st_invoices_deadlines_update',
			onSuccess: () => {
				dispatch(Utils.alertSuccessMsg(t, 'ALERT_UPDATE_SUCCESS'));
				dispatch(closeDialog());
				props.updateRefresh?.();
			}
		});
	};

	return (
		<>
			<DialogTitle>{t('DIALOG_TITLE_NOTES_EDIT')}</DialogTitle>
			<DialogContent>
				<EditorHtmlField name="indl_notes" value={model.indl_notes} sendChange={sendChange} isEdit />
			</DialogContent>
			<DialogActions>
				<Button onClick={() => dispatch(closeDialog())}>{t('DIALOG_ACTION_BACK')}</Button>
				<Button color="secondary" onClick={updateNotes}>
					{t('DIALOG_ACTION_SAVE')}
				</Button>
			</DialogActions>
		</>
	);
}
